import { render, staticRenderFns } from "./BestSelling.vue?vue&type=template&id=59dfa4bb&scoped=true"
import script from "./BestSelling.vue?vue&type=script&lang=js"
export * from "./BestSelling.vue?vue&type=script&lang=js"
import style0 from "./BestSelling.vue?vue&type=style&index=0&id=59dfa4bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dfa4bb",
  null
  
)

export default component.exports